import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { RewardProgramFragmentDoc } from '../../fragments/__generated__/RewardProgram.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RewardProgramsQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
}>;


export type RewardProgramsQuery = { rewardPrograms: { totalCount: number | null, edges: Array<{ node: { id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null } }> } };


export const RewardProgramsDocument = gql`
    query RewardPrograms($first: Int!) {
  rewardPrograms(first: $first) {
    totalCount
    edges {
      node {
        ...RewardProgramFragment
      }
    }
  }
}
    ${RewardProgramFragmentDoc}`;

/**
 * __useRewardProgramsQuery__
 *
 * To run a query within a React component, call `useRewardProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRewardProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRewardProgramsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useRewardProgramsQuery(baseOptions: Apollo.QueryHookOptions<RewardProgramsQuery, RewardProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RewardProgramsQuery, RewardProgramsQueryVariables>(RewardProgramsDocument, options);
      }
export function useRewardProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RewardProgramsQuery, RewardProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RewardProgramsQuery, RewardProgramsQueryVariables>(RewardProgramsDocument, options);
        }
export type RewardProgramsQueryHookResult = ReturnType<typeof useRewardProgramsQuery>;
export type RewardProgramsLazyQueryHookResult = ReturnType<typeof useRewardProgramsLazyQuery>;
export type RewardProgramsQueryResult = Apollo.QueryResult<RewardProgramsQuery, RewardProgramsQueryVariables>;
export function refetchRewardProgramsQuery(variables: RewardProgramsQueryVariables) {
      return { query: RewardProgramsDocument, variables: variables }
    }